module.exports = __webpack_public_path__ + "img/MES系统.6f51a53a.png";